import React, { useCallback, useMemo } from "react";

import { Checkbox } from "@app/scripts/react-general-components/Checkbox";

import type { FilterListProps } from "@app/scripts/types";

export const FilterListCheckbox: React.FC<FilterListProps & { className?: string }> = (props) => {
  const options = useMemo(() => {
    if (props?.filterListProps?.options && props?.filter?.name?.toLowerCase() === "size") {
      const order = ["OS", "XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXX"];

      return props.filterListProps.options
        .filter((o) => !o.key.includes("$"))
        ?.sort((a, b) => order.indexOf(a.key) - order.indexOf(b.key));
    }
    return props?.filterListProps?.options;
  }, [props?.filter?.name, props?.filterListProps?.options]);

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      props.filterListProps.handleChange(event.target.value);
    },
    [props.filterListProps]
  );

  return (
    <div className={props.className}>
      {options?.map((option) => (
        <Checkbox
          key={option.key}
          value={option.key}
          checked={option.checked}
          label={option.label}
          count={option.doc_count}
          onChange={onChange}
          isAge={props.filter.name === 'Age'}
        />
      ))}
    </div>
  );
};
